import { Box } from '@mui/material';
import TermsAgreement from '@/components/auth/TermsAgreement';

export interface UnitedTermsPropType {
    stateValue: {
        isAgreePolicy: boolean;
        agreePolicy: boolean;
        agreeSalesRules: boolean;
        agreePrivateRules: boolean;
        isAdult: boolean;
        agreeMarketing: boolean;
    };
    isAllAgree: boolean;
    setState: {
        setIsAgreePolicy: React.Dispatch<React.SetStateAction<boolean>>;
        setAgreePolicy: React.Dispatch<React.SetStateAction<boolean>>;
        setAgreeSalesRules: React.Dispatch<React.SetStateAction<boolean>>;
        setAgreePrivateRules: React.Dispatch<React.SetStateAction<boolean>>;
        setIsAdult: React.Dispatch<React.SetStateAction<boolean>>;
        setAgreeMarketing: React.Dispatch<React.SetStateAction<boolean>>;
    };
    handleAllAgree: (checked: boolean) => void;
}

/**
 * 가입 약관 동의 — 약식.
 *
 * 필수 항목(이용약관·개인정보·판매정책·연령)은 전부 필수라 개별 체크의 실익이 없어
 * 한 줄로 묶고, 전문은 "전체보기"로 넘긴다. 마케팅 동의만 별도 선택으로 남는다.
 *
 * 부모(`ConfirmTerms`, `UnitedSignUp`)가 6개 플래그를 각각 들고 있으므로
 * prop 인터페이스는 그대로 두고, 필수 체크 하나가 5개를 함께 움직인다.
 */
const UnitedTerms = (props: UnitedTermsPropType) => {
    const {
        isAllAgree,
        setState: { setAgreePolicy, setIsAgreePolicy, setAgreePrivateRules, setAgreeSalesRules, setIsAdult, setAgreeMarketing },
        stateValue: { agreeMarketing },
    } = props;

    // 마케팅은 건드리지 않는다 — handleAllAgree 는 마케팅까지 함께 켜므로 여기서 쓰지 않는다
    const setRequired = (checked: boolean) => {
        setIsAgreePolicy(checked);
        setAgreePolicy(checked);
        setAgreeSalesRules(checked);
        setAgreePrivateRules(checked);
        setIsAdult(checked);
    };

    return (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <TermsAgreement
                requiredAgreed={isAllAgree}
                onRequiredChange={setRequired}
                marketingAgreed={agreeMarketing}
                onMarketingChange={setAgreeMarketing}
            />
        </Box>
    );
};

export default UnitedTerms;
